module.exports = __webpack_public_path__ + "media/images/top/icon/blue/ico_arrow_circle-dd46830bc83eafbd1c547863f2f85c81.svg";